import { Settings } from '@/constants'

class AccessRoleFilter {
    filterAssistants<T extends { access: string[] }>(roles: string[] = [], assistants: T[] = []): T[] {
        let filteredList: T[] = []
        const emptyRoles = roles.length === 0
        const emptyAssistants = assistants.length === 0

        if (emptyRoles || emptyAssistants) {
            console.warn('No roles or assistants provided', roles, assistants)
            return filteredList
        }

        switch (true) {
            case roles.includes(Settings.allAccessRole):
                filteredList = assistants
                break

            default: {
                filteredList = assistants.filter((assistant) =>
                    assistant.access.some(access => roles.includes(access))
                )

                break
            }
        }

        return filteredList
    }
}

export default new AccessRoleFilter()
